import React from 'react'
import { Upload, Button, message } from 'antd'
import loadImage from 'blueimp-load-image'
const MAX_DIMENSION = 1200
// const uploadUri = process.env.REACT_APP_API_UPLOAD_URI
class ImageUploader extends React.Component {
  state = {
    loading: false
  }
  beforeUpload = (file, files) => {
    if (!file) {
      return false
    }
    this.setState({
      loading: true
    })
    loadImage(file, canvas => {
      if (canvas.type === 'error') {
        this.setState({
          loading: false
        })
        return message.error('Incorrect image')
      }
      // console.log({ canvas })
      const imgUrl = canvas.toDataURL('image/jpeg', 0.95)
      const [, mimeType, base64data] = imgUrl.match(/^data:(.+);base64,(.*)$/) || []
      if (!base64data) {
        this.setState({
          loading: false
        })
        return
      }
      this.props.onChange({
        mimeType,
        base64data
      })
      this.setState({
        loading: false
      })
    }, {
      maxWidth: MAX_DIMENSION,
      maxHeight: MAX_DIMENSION,
      contain: true,
      orientation: true,
      canvas: true
    })
    return false
  }
  // handleChange = ({ file, fileList, event }) => {
  //   this.setState({ loading: true })
  //   const { onChange } = this.props
  //   if (file.status === 'done') {
  //     const { link } = file.response
  //     onChange(link)
  //     this.setState({ loading: false })
  //   }
  // }
  render () {
    const { value } = this.props
    let imgUrl
    if (value) {
      const { mimeType, base64data } = value
      if (mimeType && base64data) {
        imgUrl = `data:${mimeType};base64,${base64data}`
      } else {
        imgUrl = value
      }
    }

    return <Upload name="file" action="" beforeUpload={this.beforeUpload} showUploadList={false}>
      {value
        ? <img src={imgUrl} alt="logo" style={{ width: 200 }}/>
        : <Button icon="upload" loading={this.state.loading}>Upload</Button>
      }
    </Upload>
  }
}

export default ImageUploader



// WEBPACK FOOTER //
// ./src/App/components/ImageUploader/ImageUploader.js